<template>
  <v-card flat>
    <v-card-text>
      <v-data-table :headers="tableColumns" :items="emailSenders" item-key="id" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <div class="flex-grow-1"></div>
            <v-dialog v-model="showDialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on" @click="handleNew">New Contact</v-btn>
              </template>
              <rooftop-contact
                v-on:close="handleClose"
                v-on:save="handleSave"
              ></rooftop-contact>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" medium class="mr-2" @click="handleEdit(item)">mdi-pencil</v-icon>
            </template>
            <span>Edit Contact</span>
          </v-tooltip>
        </template>

      </v-data-table>
   </v-card-text>
  </v-card>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import RooftopContact from './RooftopContact'

export default {
  name: 'rooftop-contacts',
  components: {
    [RooftopContact.name]: RooftopContact
  },
  props: {
    dealer: {
      type: Object,
      required: false
    },
    rooftop: {
      type: Object,
      required: false
    }
  },
  data: function () {
    return {
      showDialog: false,
      tableColumns: [
        { text: 'Job Title', value: 'job_title' },
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Phone', value: 'phone' },
        { text: 'Action', value: 'actions' }
      ]
    }
  },
  computed: {
    ...mapState('EmailSenderStore', ['emailSenders'])
  },
  methods: {
    ...mapMutations('EmailSenderStore', ['storeSender', 'resetSender', 'resetSenders']),
    refreshEmailSenders (rooftopId) {
      this.$store
        .dispatch('EmailSenderStore/fetchEmailSenders', { dealer_id: this.dealer.id, dealer_rooftop_id: rooftopId })
        .catch(error => {
          this.$flash({
            showClose: true,
            message: 'Error Loading Email Senders. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    },
    handleNew () {
      this.storeSender({ dealer_id: this.dealer.id, dealer_rooftop_id: this.rooftop.id })
    },
    handleEdit (contact) {
      this.$store.dispatch('EmailSenderStore/getEmailSender', { dealer_id: this.dealer.id, dealer_rooftop_id: this.rooftop.id, id: contact.id })
        .then(() => {
          this.showDialog = true
        })
        .catch(error => {
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: 'Error loading Rooftop Contact. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    },
    handleSave (contact) {
      this.$store.dispatch('EmailSenderStore/fetchEmailSenders', { dealer_id: contact.dealer_id, dealer_rooftop_id: contact.dealer_rooftop_id })
        .catch(error => {
          this.$logger.error(error.message)
          this.$flash({
            showClose: true,
            message: 'Error saving Rooftop Contact. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    },
    handleClose () {
      this.showDialog = false
    }
  },
  watch: {
    rooftop: {
      immediate: true,
      handler (newRooftop) {
        if (newRooftop.id) {
          this.refreshEmailSenders(newRooftop.id)
        } else {
          this.resetSender()
          this.resetSenders()
        }
      }
    }
  }
}
</script>
